var PeopleMedia = PeopleMedia || {};
PeopleMedia.ExternalSearch = (function ($jq) {
    "use strict";
    var Oid = "PeopleMedia.ExternalSearch";
    var totalMembers = 0;
    var totalPages = 0;

    var searchClick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        var profileId = $jq(this).attr("data-encodedmemberid");
        if (profileId) {
            window.location.href = "/v3/profile?profile=" + PeopleMedia.htmlEscape(profileId);
        }
    };

    var initialize = function (options) {
        try {
            if (options) {
                if (options.totalMembers > 0) {
                    totalMembers = options.totalMembers;
                }
                if (options.totalPages > 0) {
                    totalPages = options.totalPages;
                }
            }
            if (totalMembers <= 0) {
                $jq("#paginationsearch").hide();
            }
            $jq(".results").on("click", ".js-searchresult.clickable", searchClick);
        } catch (ex) {
            PeopleMedia.Logger.LogExceptionWithDetail(ex, { Oid: Oid, method: "initialize" });
        }
    };

    return {
        initialize: initialize
    };
})(jQuery);